import { render, staticRenderFns } from "./analyze.vue?vue&type=template&id=0ab92672&scoped=true&"
import script from "./analyze.vue?vue&type=script&lang=js&"
export * from "./analyze.vue?vue&type=script&lang=js&"
import style0 from "./analyze.vue?vue&type=style&index=0&id=0ab92672&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab92672",
  null
  
)

export default component.exports